import * as React from "react";
import { forwardRef } from "react";
const SvgLogoStackState = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M15.402 23.6788L8.75114 19.8248L5.83409 21.4891L15.402 27.0073C15.7812 27.2409 16.2771 27.2409 16.6563 27.0073L26.2242 21.4891L23.3364 19.8248L16.6855 23.6788C16.2771 23.9124 15.8104 23.9124 15.402 23.6788Z",
	fill: "currentColor"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M15.402 17.7518L8.75114 13.8978L5.83409 15.5912L15.402 21.1095C15.7812 21.3431 16.2771 21.3431 16.6563 21.1095L26.2242 15.5912L23.3364 13.8978L16.6855 17.7518C16.2771 17.9854 15.8104 17.9854 15.402 17.7518Z",
	fill: "currentColor"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M5.83409 9.78102L16.0438 3.88321L26.2534 9.78102L16.6855 15.2993C16.3063 15.5328 15.8104 15.5328 15.4312 15.2993L5.83409 9.78102Z",
	fill: "currentColor"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M3.73382 21.1095C3.73382 20.6715 3.96718 20.2336 4.37557 20.0292L6.65087 18.7153L4.43391 17.4307C4.05469 17.1971 3.79216 16.7883 3.79216 16.3504V15.1825C3.79216 14.7445 4.02552 14.3066 4.43391 14.1022L6.6217 12.8175L4.43391 11.562C4.05469 11.3285 3.79216 10.9197 3.79216 10.4818V9.48905C3.79216 9.0219 4.02552 8.61314 4.43391 8.37956L14.8769 2.33577V0C6.56335 0.583942 0 7.50365 0 15.9708C0 18.8029 0.729262 21.4599 2.01276 23.7664L3.73382 22.7737V21.1095Z",
	fill: "currentColor"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M27.5369 8.29197C27.9161 8.52555 28.1787 8.93431 28.1787 9.40146V10.3942C28.1787 10.8321 27.9453 11.2701 27.5369 11.4745L25.3491 12.7299L27.5369 14.0146C27.9453 14.219 28.1787 14.6569 28.1787 15.0949V16.2336C28.1787 16.6715 27.9453 17.1095 27.5369 17.3139L25.32 18.5985L27.5953 19.9124C27.9745 20.146 28.237 20.5547 28.237 20.9927V22.6569L29.9872 23.6788C31.2707 21.3723 32 18.7153 32 15.9124C32 7.44526 25.4366 0.583942 17.1231 0V2.24818L27.5369 8.29197Z",
	fill: "currentColor"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M16.6855 29.4015C16.3063 29.635 15.8104 29.635 15.4312 29.4015L5.86326 23.9124L4.11304 24.9051L3.90884 25.0219L3.12124 25.4891C6.03829 29.4307 10.7347 32 16.0146 32C21.2944 32 25.9617 29.4599 28.8788 25.5182L26.1659 23.9708L16.6855 29.4015Z",
	fill: "currentColor"
}));
const ForwardRef = forwardRef(SvgLogoStackState);
export default ForwardRef;
